import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Divider, Grid, KeyValue, Progress, SectionHeader} from 'web-library';
import {useHistory, useParams} from 'react-router-dom';
import FormHeader from '../../../components/form-items/FormHeader';
import RouteKey from '../../../routes/key';
import {
    TransactionRecordDetailsResponseModel,
    useGetTransactionListing,
} from '../../../api-refactored/transaction/useGetTransactionDetailsListing';
import TransactionDetails from '../@candidate/TransactionDetails';

interface CandidateDetailsProps {
  getCoordinatorDetailsText: (key: string) => string;
  model: TransactionRecordDetailsResponseModel;
}

const CandidateDetails = ({ getCoordinatorDetailsText, model }: CandidateDetailsProps) => (
  <>
    <FormHeader title={getCoordinatorDetailsText('Header')} />
    <KeyValue keyText={getCoordinatorDetailsText('Name')} valueText={model.name} />
    <Grid container>
      <Grid xl={4} lg={5} md={12} sm={12} xs={12}>
        <KeyValue keyText={getCoordinatorDetailsText('Id')} valueText={model.userIdType} />
      </Grid>
      <Grid xl={4} lg={5} md={12} sm={12} xs={12}>
        <KeyValue keyText={getCoordinatorDetailsText('IdValue')} valueText={model.nric} />
      </Grid>
    </Grid>
    <KeyValue keyText={getCoordinatorDetailsText('ExamLevel')} valueText={model.examLevel} />
  </>
);
const { transaction } = RouteKey.child;
const { coordinator } = RouteKey.transaction.child;

const ViewDetails = () => {
  const { t } = useTranslation();

  const { candidateUuid } = useParams<any>();
  const history = useHistory();
  const getCoordinatorDetailsText = (key: string) =>
    t(`transaction->>Coordinator.CandidateDetails.${key}`);

  const { data, isLoading } = useGetTransactionListing({
    candidateUuid,
  });

  return (
    <>
      <SectionHeader title={t('transaction->>Page.SubHeader.TransactionSummary')} />
      {isLoading && <Progress />}
      {data && (
        <>
          <CandidateDetails getCoordinatorDetailsText={getCoordinatorDetailsText} model={data} />
          <TransactionDetails model={data} />
        </>
      )}
      <Divider paddingTop />
      <Button
        color="secondary"
        size="medium"
        variant="outlined"
        onClick={() => {
          history.push(`/${transaction}/${coordinator.route}`);
        }}
      >
        {getCoordinatorDetailsText('Back')}
      </Button>
    </>
  );
};

export default ViewDetails;
